import ReactDOM from "react-dom/client";
import { HelmetProvider } from 'react-helmet-async';
import App from "./App";
import { ApolloProvider } from '@apollo/client';
import client from './lib/apollo-client';
import "./index.css";

const container = document.getElementById("root");
const app = (
  <ApolloProvider client={client}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </ApolloProvider>
);

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  const root = ReactDOM.createRoot(container);
  root.render(app);
}
